import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
      data-testid="hero-section"
      style={{
        backgroundImage: 'url(https://images.pexels.com/photos/7698712/pexels-photo-7698712.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900/90 via-slate-900/85 to-teal-900/80"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/20 backdrop-blur-sm border border-teal-400/30 rounded-full mb-8 animate-fadeIn" data-testid="hero-badge">
          <Sparkles className="w-4 h-4 text-teal-300" />
          <span className="text-sm font-semibold text-teal-200 uppercase tracking-wider">Growth Marketing Experts</span>
        </div>

        <h1
          className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-white leading-tight mb-6"
          data-testid="hero-title"
        >
          Transform Your Brand with
          <span className="block bg-gradient-to-r from-teal-300 to-cyan-300 bg-clip-text text-transparent">
            Viral Marketing Strategies
          </span>
        </h1>

        <p
          className="text-xl sm:text-2xl text-slate-200 leading-relaxed max-w-3xl mx-auto mb-12"
          data-testid="hero-description"
        >
          We create rapid growth campaigns that make your business go viral. From social media to lead generation, we've scaled businesses across Delhi NCR.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={scrollToContact}
            className="group bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 flex items-center gap-2"
            data-testid="hero-cta-primary"
          >
            Get Free Consultation
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="tel:9068922387"
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-full text-lg font-bold transition-all duration-300"
            data-testid="hero-cta-secondary"
          >
            Call: 9068922387
          </a>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 max-w-4xl mx-auto">
          <div className="text-center" data-testid="stat-clients">
            <div className="text-4xl font-black text-teal-300 mb-2">100+</div>
            <div className="text-slate-300 font-medium">Happy Clients</div>
          </div>
          <div className="text-center" data-testid="stat-campaigns">
            <div className="text-4xl font-black text-teal-300 mb-2">500+</div>
            <div className="text-slate-300 font-medium">Campaigns</div>
          </div>
          <div className="text-center" data-testid="stat-leads">
            <div className="text-4xl font-black text-teal-300 mb-2">10K+</div>
            <div className="text-slate-300 font-medium">Leads Generated</div>
          </div>
          <div className="text-center" data-testid="stat-roi">
            <div className="text-4xl font-black text-teal-300 mb-2">300%</div>
            <div className="text-slate-300 font-medium">Average ROI</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/60 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;